import { getPlatforms } from '@ionic/react'
import Plausible, { type EventOptions } from 'plausible-tracker'
import { PLAUSIBLE_DOMAIN } from '../data/environment'

const plausible = Plausible({
  domain: PLAUSIBLE_DOMAIN,
  trackLocalhost: !getPlatforms().includes('desktop'),
})

export const trackEvent = (name: string, options?: EventOptions) => {
  plausible?.trackEvent(name, options)
}

export const trackPageview = () => {
  plausible?.trackPageview()
}

export const enableAutoPageviews = () => {
  plausible?.enableAutoPageviews()
}
